// index.js
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";

import { ModalProvider } from "./context/ModalContext"; // 👈 import the provider
import NotificationModal from "./components/notificationModal"; // 👈 add modal at root

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <ModalProvider>
      <App />
      <NotificationModal /> {/* 👈 render globally, outside Sidebar or Layout */}
    </ModalProvider>
  </BrowserRouter>
);
